import { TextInput, BooleanInput, NumberInput, required } from 'react-admin';
import { Stack, Typography } from '@mui/material';
import { ImageUploadInput } from '../../components/ImageUploadInput.jsx';
import { ItalicHeadlineInput } from '../../components/ItalicHeadlineInput.jsx';

export const SlideForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 720 }}>
    <ImageUploadInput source="image" label="Slide image" validate={required()} />

    <TextInput source="eyebrow" label="Eyebrow (small uppercase line)" fullWidth />
    <ItalicHeadlineInput source="headline" label="Headline" validate={required()} />
    <TextInput source="subline" label="Subline" multiline minRows={2} fullWidth />

    <Typography variant="overline" color="text.secondary">Primary button</Typography>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextInput source="primaryButtonLabel" label="Label" fullWidth />
      <TextInput source="primaryButtonUrl" label="URL" fullWidth />
    </Stack>

    <Typography variant="overline" color="text.secondary">Secondary button</Typography>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextInput source="secondaryButtonLabel" label="Label" fullWidth />
      <TextInput source="secondaryButtonUrl" label="URL" fullWidth />
    </Stack>

    <Stack direction="row" spacing={2}>
      <NumberInput source="sortOrder" label="Sort order" defaultValue={0} />
      <BooleanInput source="isActive" label="Active" defaultValue={true} />
    </Stack>
  </Stack>
);
